/**
 * 唤起安全键盘
 * 目前适用于随手记
 */
import useragent from '@common/useragent'
import { call, uriSuishouji } from './bridge'
import { compare } from './version'

export default (callbackName) => {
  if (useragent.isSuishouji) {
    if ((useragent.isAndroid && compare('10.3.7.0')) || (useragent.isIOS && compare('10.6.9') && compare('9.0.0', useragent.detail.os.version))) {
      document.activeElement.blur()
      call(uriSuishouji('requestSecurityKeypad', {}, callbackName))
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestSecurityKeypad.js